<template>
    <console-layout width="100%" max-width="1280">
        <console-title>
            <span>문자 / 알림톡 / 이메일</span>
        </console-title>

        <console-body>
            <v-layout class="align-end">
                <span class="subtitle-2">검색수 : {{ summary.totalCount.format() }}</span>
                <v-spacer />
                <span>
                </span>
            </v-layout>
    
            <v-data-table :items="receptions" :headers="receptionsHeaders" hide-default-footer disable-sort disable-pagination class="mt-2 elevation-1">
                <template #[`item.actions`]="{item}">
                    <v-icon small class="mx-1" @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon small class="mx-1" @click="remove(item)">mdi-delete</v-icon>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>
        </console-body>

        <v-btn fab fixed bottom right color="accent" to="/console/receptions/create"><v-icon>mdi-pencil</v-icon></v-btn>

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 20,

            summary: { totalCount: 0 },
            receptions: [],
            receptionsHeaders: [
                { text: "code", value: "code", align: "center", width: 200 },
                { text: "이름", value: "name", align: "center", /* width: 10 */ },
                { text: "문자/알림톡 고객수신", value: "message.memberEnabled", align: "center", width: 110 },
                { text: "문자/알림톡 관리자수신", value: "message.adminEnabled", align: "center", width: 110 },
                { text: "이메일 고객수신", value: "email.memberEnabled", align: "center", width: 90 },
                { text: "이메일 관리자수신", value: "email.adminEnabled", align: "center", width: 100 },
                { text: "actions", value: "actions", align: "center", width: 100 },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, receptions } = await api.console.common.receptions.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.receptions = receptions;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        edit(reception){
            this.$router.push(`/console/receptions/${reception._id}`);
        },

        async remove(reception){
            if(confirm("수신설정을 삭제하시겠습니까?")){
                await api.console.common.receptions.delete(reception);
                this.search(false);
            }
        },
        async excel(){
            let { receptions } = await api.console.common.receptions.gets({ headers: { limit: 0 }, params: this.filter });

            let rows = [];
            receptions.forEach(reception => {
                rows.push({
                    "no": reception.no,
                    "이름": reception.name,
                });
            });

            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "엑셀시트이름");
            XLSX.writeFile(workbook, "엑셀파일이름.xlsx");
        }
    }
}
</script>